import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { client, setCSRFToken } from '../../lib/api/hwadap';
import useStore from '../../store/hwadap/store';
import Loader from '../../components/common/Loader';

const LoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get('token') ?? '';
  const user = useStore((state) => state.user);
  const setUser = useStore((state) => state.setUser);

  // 웹뷰 닫기
  const closeWebView = () => {
    try {
      const agent = navigator.userAgent.toLowerCase();
      if (agent.indexOf('android') > -1) {
        window.Android.viewClose();
      } else if (agent.indexOf("iphone") > -1 || agent.indexOf("ipad") > -1 || agent.indexOf("ipod") > -1 || agent.indexOf("apple") > -1) {
        window.webkit.messageHandlers.viewClose.postMessage("1");
      } else {
        // setPopup({ type: 'alert', message: 'No native APIs found.', isOpen: true });
      }
    } catch (e) {
      alert('네이티브 웹뷰 닫기 호출');
      navigate('/');
    }
  }

  /** CSRF + Access 토큰 받기 */
  const getToken = () => {
    try {
      console.log(token);
      if (user.userId.length > 0) {
        navigate(`/hwadap/room`);
      }
      // 임시
      // setUser({ userId });
      // navigate(`/hwadap/room?langcd=${langCd}`);
      // 임시
      
      // const { data } = await client.get('', token);
      // if ('failed') {
      //   return;
      // }
      // if ('Success') {
      //   setCSRFToken('123');
      //   navigate(`/hwadap/room?langcd=${langCd}`);
      // }      
    } catch (e) {
      console.log(e);
    }
  }

  useEffect(() => {
    if (user.userId.length > 0) {
      closeWebView();
    } else {
      // getToken(token);
    }
  }, []);

  return (
    // <Loader />
    <div style={{ display: 'flex', height: '100vh', alignItems: 'center', justifyContent: 'center', padding: '3rem' }}>
      <div style={{ width: '100%', textAlign: 'center' }}>
        <input type="text" value={user.userId} onChange={(e) => setUser({ userId: e.target.value })} />
        <br/>
        <br/>
        <button type='button' onClick={getToken} style={{ fontSize: '2rem' }}>로그인</button>
      </div>
    </div>
  )
}

export default LoginPage;